import * as PortalNamespace from './PortalNamespace';

export { default as Portal } from './Portal';
export { default as PortalElement } from './PortalElement';
export { PortalNamespace };
